import { useEffect, useState } from "react";
import ReplayIcon from "@mui/icons-material/Replay";
import StatisticsService from "../../../services/statistics.service";
import StatCard from "./StatCard";

export default function ReturningActiveMembersStat() {
  const [value, setValue] = useState(null);
  const [description, setDescription] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    StatisticsService.getTotalReturningActiveMembers().then(({ data, description, error }) => {
      if (error) setError(error);
      else {
        setValue(data);
        setDescription(description);
      }
    });
  }, []);

  return (
    <StatCard
      icon={ReplayIcon}
      value={value}
      label="Usuarios recurrentes con membresía activa"
      description={description}
      error={error}
      iconColor="success.main"
    />
  );
}
